import styled from 'styled-components';
import Measurements from '../theme/measurements';

const InnerContent = styled.div<{ isScrollable?: boolean }>`
  display: flex;
  flex-direction: column;
  height: calc(100vh - ${Measurements.TEAM_TOP_BAR_HEIGHT});
  overflow-y: ${(props) => (props.isScrollable ? 'scroll' : 'hidden')};
`;

export default InnerContent;
